import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

export default {
  actions: {
    async [actions.DO_DELETE_EVENT_REGISTRATION]({ commit }, payload) {
      const { id, ignore, ...params } = payload;
      const { data } = await HTTP.delete(`/registrations/${id}`, params);
      if (!ignore) commit(mutations.SET_EVENT_REGISTRATION, data.data.registrations[0]);
      return data;
    },
    async [actions.DO_DELETE_EVENT_REGISTRATIONS]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.delete(`/events/${id}/registrations`, params);
      commit(mutations.SET_EVENT_REGISTRATIONS, []);
      return data;
    },
    async [actions.DO_GET_EVENT_REGISTRATION]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/registrations/${id}`, { params });
      commit(mutations.SET_EVENT_REGISTRATION, data.data.registrations[0]);
      return data;
    },
    async [actions.DO_GET_EVENT_REGISTRATIONS]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/events/${id}/registrations`, { params });
      commit(mutations.SET_EVENT_REGISTRATIONS, data.data.registrations);
      return data;
    },
  },
  getters: {
    [getters.GET_EVENT_REGISTRATION]: state => state.registration,
    [getters.GET_EVENT_REGISTRATION_REFRESH]: state => state.refresh,
    [getters.GET_EVENT_REGISTRATIONS]: state => state.registrations,
  },
  mutations: {
    [mutations.SET_EVENT_REGISTRATION](state, registration) {
      state.registration = registration;
    },
    [mutations.SET_EVENT_REGISTRATION_REFRESH](state, refresh) {
      state.refresh = refresh;
    },
    [mutations.SET_EVENT_REGISTRATIONS](state, registrations) {
      state.registrations = registrations;
    },
  },
  state: {
    refresh: false,
    registration: {},
    registrations: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/event_registration.js